// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2qGsw","productName":"Table_productName__2QTtI"};